// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1-YNI","selects":"Documents_selects__3EOoB"};